export const vaultAdd = 'add';
export const vaultAdmin = 'admin';
export const vaultDelete = 'delete';
export const vaultRead = 'read';
export const vaultUpdate = 'update';
export const vaultLaunch = 'launch';

export const Administrator = 'Administrator';
export const Audit = 'Audit';
export const ManageAccount = 'ManageAccount';
export const ManageSystem = 'ManageSystem';
export const ManageVault = 'ManageVault';
export const ReadDirectory = 'ReadDirectory';
export const ManageLicense = 'ManageLicense';

export const ManagePod = 'ManagePod';
export const ManageTenant = 'ManageTenant';
export const SupportTenant = 'SupportTenant';
export const NotifyTenant = 'NotifyTenant';

export const PolicyCreation = 'PolicyCreation';

export const VaultExporter = 'VaultExporter';